import React, { createContext, useContext, ReactNode } from 'react';

interface LocalStorageContextProps {
  saveItem: (name: string, value: any) => void;
  deleteItem: (name: string) => void;
  getItem: (name: string) => string | null;
}

const LocalStorageContext = createContext<LocalStorageContextProps | undefined>(undefined);

export const LocalStorageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const saveItem = (name: string, value: string) => {
    localStorage.setItem(name, JSON.stringify(value));
  };

  const deleteItem = (name: string) => {
    localStorage.removeItem(name);
  };

  const getItem = (name: string) => {
    return localStorage.getItem(name);
  };

  return (
    <LocalStorageContext.Provider value={{ saveItem, deleteItem, getItem }}>
      {children}
    </LocalStorageContext.Provider>
  );
};

export const useLocalStorage = (): LocalStorageContextProps => {
  const context = useContext(LocalStorageContext);
  if (!context) {
    console.warn('useLocalStorage must be used within a LocalStorageProvider');
    return {
      saveItem: () => {},
      deleteItem: () => {},
      getItem: () => null,
    };
  }
  return context;
};